module.exports = __webpack_public_path__ + "fonts/boxicons.b5e3cc0c.woff2";